export function formatDateForFilename() {
  var now = new Date();
  var pad = function pad(n) {
    return String(n).padStart(2, '0');
  };
  var year = now.getFullYear();
  var month = pad(now.getMonth() + 1);
  var day = pad(now.getDate());
  var hour = pad(now.getHours());
  var minute = pad(now.getMinutes());
  var second = pad(now.getSeconds());
  return "".concat(year, "-").concat(month, "-").concat(day, "_").concat(hour, "-").concat(minute, "-").concat(second);
}